/*eslint react-hooks/exhaustive-deps: "off"*/
import normalizeText from 'normalize-text';
import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

const ShowOnWrapper = ({ children, input }) => {
  const { watch } = useFormContext();
  const [component, setComponent] = useState(children);

  const init = useCallback(() => {
    if (input.showOn) {
      //  console.log(input.name);

      const field = watch(input.showOn.codCore, undefined);

      if (field) {
        if (typeof input.showOn.value !== 'string') {
          console.log(input.showOn.value, field, input.showOn.value);
          if (field === input.showOn.value) {
            return setComponent(children);
          } else {
            return setComponent(null);
          }
        }

        const showsOn = normalizeText(input.showOn.value.toLowerCase()).split(
          ',',
        );
        if (!showsOn.includes(normalizeText(field.toLowerCase()))) {
          return setComponent(null);
        }
      }
    }
    else if (input.showOff) {
      const field = watch(input.showOff.codCore, undefined);
      if (field) {
        const showsOn = normalizeText(input.showOff.value.toLowerCase()).split(
          ',',
        );
        if (showsOn.includes(normalizeText(field.toLowerCase()))) {
          return setComponent(null);
        }
      }
    }
    return setComponent(children);
  }, []);

  useEffect(() => {
    init();
  });

  return component;
};

export default ShowOnWrapper;
